
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timelapse/publish/[id]",
      function () {
        return require("private-next-pages/timelapse/publish/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timelapse/publish/[id]"])
      });
    }
  